export default {
  activeButtonsName: ["Активные", "Неактивные"],
};
